import { cookieUtils } from "./cookieUtils";

const EXACT_PUBLIC_PATHS = ["/", "/login", "/signup", "/confirm", "/landing", "/support"];
// /super-admin runs its own auth (super_admin_session cookie), entirely
// separate from tenant/Cognito login — a 401/403 there must not trigger the
// tenant-session-expired flow (wrong cookie, wrong redirect target).
const PREFIX_PUBLIC_PATHS = ["/invite", "/bootstrap", "/widget", "/super-admin"];

export function normalizePath(pathname) {
  if (!pathname) return "/";
  return pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
}

export function isPublicAuthPage(pathname = window.location.pathname) {
  const normalized = normalizePath(pathname);

  if (EXACT_PUBLIC_PATHS.includes(normalized)) {
    return true;
  }

  return PREFIX_PUBLIC_PATHS.some(
    (prefix) =>
      normalized === prefix || normalized.startsWith(`${prefix}/`),
  );
}

export function hadPriorSession() {
  return Boolean(
    cookieUtils.getAuthValue("userid") ||
      cookieUtils.getAuthValue("email") ||
      cookieUtils.getAuthValue("tenant") ||
      localStorage.getItem("user"),
  );
}
